exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-footer {\n  bottom: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/js/components/displays/Totals/totals.scss
// module id = 184
// module chunks = 0